import { TranslationRepository } from '../data/translation-repository';
import { TranslationsResponse, ApplicationType } from '../types/translation-types';

export class GetAllTranslationsUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  /**
   * Fetch all translations for an application type in a single request.
   * Uses a large page size to get all items at once.
   */
  async execute(applicationType: ApplicationType): Promise<TranslationsResponse> {
    // Fetch all translations with a large take value
    // The backend should return all items (typically ~500 per app)
    return this.repository.getTranslations({
      applicationType,
      skip: 0,
      top: 10000, // Large enough to get all translations
      orderBy: 'keyName',
    });
  }
}
